import enUS from './en-US';
import uk from './uk';
import de from './de';

export default {
  'en-US': enUS,
  de,
  uk,
};
